import { DateTime } from 'luxon';
import { getConfig } from './config';
import _ from 'lodash';

const ANTI_NUMBER_REGEX = new RegExp('[^-.\\d]', 'g');

export function parseDate (str) {
  if (str === undefined || str === null)
  {
    return null;
  }

  let date = parseISODate(str);

  if (date !== null) {
    return date;
  }

  let patterns = getConfig('parse.date').split('|');
  patterns.find((p) => {
    let test = DateTime.fromFormat(str, p);
    if (test.invalid === null)
    {
      date = test;
    }

    return date !== null;
  });

  return date;
}

export function parseISODate (str) {
  if (str === undefined || str === null || !str.match(/^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2})?/))
  {
    return null;
  }

  let date = null;
  let test = DateTime.fromISO(str);
  if (test.invalid === null)
  {
    date = test;
  }

  return date;
}

// hook function used to perform date manipulation in our date fields, e.g. "c+7". implementations may choose to
// override this to provide custom functionality. Must return a promise that resolves with the final value (a date
// string properly formatted).
export function processDatePickerShortcut (str) {
  return Promise.resolve(str);
}

export function parseTime (str) {
  if (str === undefined || str === null)
  {
    return null;
  }

  let date = parseISODate(str);

  if (date !== null) {
    return date;
  }

  let patterns = getConfig('parse.time').split('|');
  patterns.find((p) => {
    let test = DateTime.fromFormat(str, p);
    if (test.invalid === null)
    {
      date = test;
    }

    return date !== null;
  });

  return date;
}

export function parseNumber (str) {
  let result = null;
  if (!_.isNil(str))
  {
    let value = str;
    let locale = getConfig('locale');
    let parts = new Intl.NumberFormat(locale).formatToParts(1.23);
    let decimalChar = parts.find((p) => { return p.type === 'decimal'; }).value;

    // locale aware decimal replacement (parseFloat ONLY works with '.' for decimal point representation)
    if (decimalChar !== '.')
    {
      value = value.replaceAll('.', '');
      value = value.replaceAll(decimalChar, '.');
    }

    // remove all non-numeric characters
    value = value.replace(ANTI_NUMBER_REGEX, '');

    let parsed = parseFloat(value);
    result = !isNaN(parsed) ? parsed : null;
  }

  return result;
}